import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './words-left.module.scss'

interface WordsLeftProps {
  wordCount: number
  minWordCount?: number
}

export const WordsLeft: React.FC<WordsLeftProps> = ({ wordCount, minWordCount = 0 }) => {
  const wordsLeft = minWordCount - wordCount

  return (
    <div className={styles.wordsLeft}>
      {wordCount && wordsLeft > 0 ? (
        <span>
          <FormattedMessage
            id="textChecker.reportFlow.wordsLeft.copy"
            description="Text Checker - Report Flow - Words Left - Copy"
            defaultMessage="Enter {count} more {words}"
            values={{
              count: <strong>{wordsLeft}</strong>,
              words: wordsLeft > 1 ? 'words' : 'word',
            }}
          />
        </span>
      ) : null}
    </div>
  )
}
